var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBottomGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72015 6.77992C6.57963 6.92061 6.38899 6.99975 6.19015 6.99992H5.81015C5.61173 6.99762 5.42187 6.9188 5.28015 6.77992L0.150147 1.63992C0.0554914 1.54604 0.00224876 1.41824 0.00224876 1.28492C0.00224876 1.1516 0.0554914 1.0238 0.150147 0.929921L0.860147 0.219921C0.952312 0.125857 1.07846 0.0728492 1.21015 0.0728492C1.34184 0.0728492 1.46798 0.125857 1.56015 0.219921L6.00015 4.66992L10.4401 0.219921C10.534 0.125264 10.6618 0.0720215 10.7951 0.0720215C10.9285 0.0720215 11.0563 0.125264 11.1501 0.219921L11.8501 0.929921C11.9448 1.0238 11.998 1.1516 11.998 1.28492C11.998 1.41824 11.9448 1.54604 11.8501 1.63992L6.72015 6.77992Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottomGrey);
export default __webpack_public_path__ + "static/media/chevronBottomGrey.b0aeb081.svg";
export { ForwardRef as ReactComponent };